export default __webpack_public_path__ + "static/media/edit-profile-icon.2dc68bd1.svg";